import React from "react";
import { TableCell, TableRow } from "@mui/material";

const InfoRow = ({ label, children }) => (
  <TableRow
    sx={{
      "&:nth-of-type(even)": {
        backgroundColor: theme => theme.palette.tableStripe?.main ?? theme.palette.action.hover,
      },
    }}
  >
    <TableCell
      sx={{ fontWeight: "bold", width: "35%", verticalAlign: "top", whiteSpace: "nowrap" }}
    >
      {label}
    </TableCell>
    <TableCell sx={{ verticalAlign: "top" }}>{children}</TableCell>
  </TableRow>
);

export default InfoRow;
